/** Default and per-section SEO copy for Spinx888 (slots, fishing, Shan Koe Mee, Bugyi, live casino, card games). */

/** Protocol + host (no trailing slash). Uses the live URL so one build works on Spinx888 domains. */
export function getSiteOrigin() {
  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    return window.location.origin;
  }
  return '';
}

/**
 * Absolute canonical URL for a route pathname (must match router SEO / index.html bootstrap).
 * @param {string} [path] pathname e.g. /home (query/hash ignored)
 */
export function getCanonicalUrlForPath(path) {
  const pathname = ((path || '/').split('?')[0] || '/').replace(/\/+$/, '') || '/';
  const origin = getSiteOrigin();
  if (!origin) return '';
  return pathname === '/' ? origin : `${origin}${pathname}`;
}

const BASE_DESC =
  'Spinx888 offers online slots, fishing arcade games, Shan Koe Mee (Shan poker), Bugyi and classic card games, plus live casino with real dealers. Play securely, fast deposits and withdrawals, promotions for Myanmar players.';

const BASE_KEYWORDS =
  'Spinx888, online slots, slot games, fishing game, fishing arcade, Shan Koe Mee, Shan poker, ဘူဂျီ, Bugyi, Bugyee, online card games, live casino, live dealer, baccarat, roulette, Myanmar online casino, jackpot slots';

export const siteDefaults = {
  title: 'Spinx888 | Online Slots, Fishing, Shan Koe Mee, Bugyi, Live Casino & Card Games',
  description: BASE_DESC,
  keywords: BASE_KEYWORDS,
};

export const pageMeta = {
  home: siteDefaults,

  slots: {
    title: 'Online Slot Games | Spinx888 — Jackpots & Popular Slots',
    description:
      'Play hundreds of online slot games at Spinx888: classic reels, video slots, jackpots and bonus features. Fast play, fair results, mobile-friendly.',
    keywords: `${BASE_KEYWORDS}, video slots, jackpot slots, slot bonus`,
  },

  fishing: {
    title: 'Fishing Arcade Games Online | Spinx888',
    description:
      'Shoot-and-catch fishing arcade games at Spinx888. Colorful tables, multipliers and real-time action—popular in Myanmar and Southeast Asia.',
    keywords: `${BASE_KEYWORDS}, fishing shooter game, arcade fishing`,
  },

  liveCasino: {
    title: 'Live Casino & Live Dealer Games | Spinx888',
    description:
      'Live casino at Spinx888: real dealers, HD streams, baccarat, roulette and more. Feel like a real casino floor from your phone or desktop.',
    keywords: `${BASE_KEYWORDS}, live baccarat, live roulette, HD casino stream`,
  },

  shanKoeMee: {
    title: 'Shan Koe Mee Online Rooms | Spinx888',
    description:
      'Join Shan Koe Mee (Shan poker) tables at Spinx888. Play with friends or match online—authentic card rules and smooth gameplay.',
    keywords: `${BASE_KEYWORDS}, Shan Koe Mee room, Shan poker online`,
  },

  bugyee: {
    title: 'Bugyi (Bugyee) Card Game Online | Spinx888',
    description:
      'Play Bugyi / Bugyee card games online at Spinx888. Traditional Myanmar-style card play with reliable tables and quick rounds.',
    keywords: `${BASE_KEYWORDS}, Bugyi online, Bugyee card game`,
  },

  cardGames: {
    title: 'Online Card Games & Tables | Spinx888',
    description:
      'Card games and table games at Spinx888 alongside slots and live casino. One account for multiple game types.',
    keywords: `${BASE_KEYWORDS}, table games, multiplayer cards`,
  },

  arcade: {
    title: 'Arcade & Casual Games | Spinx888',
    description: 'Arcade and casual games at Spinx888—quick fun between slots, fishing and live casino sessions.',
    keywords: `${BASE_KEYWORDS}, arcade games online`,
  },

  promotion: {
    title: 'Casino Promotions & Bonuses | Spinx888',
    description:
      'Latest Spinx888 promotions: welcome offers, reload bonuses and cashback for slots, live casino and card games. Check terms on each offer.',
    keywords: `${BASE_KEYWORDS}, casino bonus, welcome bonus, cashback`,
  },

  login: {
    title: 'Member Login | Spinx888',
    description: 'Log in to your Spinx888 account to play slots, fishing, Shan Koe Mee, Bugyi, live casino and card games.',
    keywords: `${BASE_KEYWORDS}, Spinx888 login`,
  },

  register: {
    title: 'Register & Join | Spinx888',
    description:
      'Create a Spinx888 account in minutes. Access slots, fishing games, Shan Koe Mee, Bugyi, live casino and secure banking.',
    keywords: `${BASE_KEYWORDS}, Spinx888 register, sign up`,
  },

  contact: {
    title: 'Contact Us | Spinx888',
    description: 'Contact Spinx888 support for account, deposits, withdrawals and game questions.',
    keywords: `${BASE_KEYWORDS}, Spinx888 support, customer service`,
  },

  rule: {
    title: 'Rules & Terms | Spinx888',
    description: 'Rules, terms and responsible play information for Spinx888 members.',
    keywords: `${BASE_KEYWORDS}, terms and conditions`,
  },

  deposit: {
    title: 'Deposit | Spinx888',
    description: 'Deposit funds securely to play slots, fishing, live casino and card games at Spinx888.',
    keywords: `${BASE_KEYWORDS}, deposit`,
    robots: 'noindex, nofollow',
  },

  withdraw: {
    title: 'Withdraw | Spinx888',
    description: 'Withdraw your winnings from Spinx888 with supported payment methods.',
    keywords: `${BASE_KEYWORDS}, withdraw`,
    robots: 'noindex, nofollow',
  },

  banking: {
    title: 'Banking | Spinx888',
    description: 'Banking and payment options for Spinx888 members.',
    keywords: `${BASE_KEYWORDS}, banking`,
    robots: 'noindex, nofollow',
  },

  history: {
    title: 'Transaction History | Spinx888',
    description: 'View your Spinx888 transaction history.',
    robots: 'noindex, nofollow',
  },

  setting: {
    title: 'Account Settings | Spinx888',
    description: 'Manage your Spinx888 account settings.',
    robots: 'noindex, nofollow',
  },

  betslip: {
    title: 'Betslip History | Spinx888',
    description: 'Your betslip history at Spinx888.',
    robots: 'noindex, nofollow',
  },

  liveScore: {
    title: 'Live Score | Spinx888',
    description: 'Live scores and sports updates at Spinx888.',
    keywords: BASE_KEYWORDS,
  },

  matchResult: {
    title: 'Football Match Results | Spinx888',
    description: 'View today and yesterday football match results at Spinx888.',
    keywords: `${BASE_KEYWORDS}, football results, match results`,
  },

  maungFb: {
    title: 'Maung FB | Spinx888',
    description: 'Maung FB at Spinx888.',
    keywords: BASE_KEYWORDS,
  },

  bodyFb: {
    title: 'Body FB | Spinx888',
    description: 'Body FB at Spinx888.',
    keywords: BASE_KEYWORDS,
  },

  videoLinks: {
    title: 'Video Links | Spinx888',
    description: 'Video links and guides at Spinx888.',
    keywords: BASE_KEYWORDS,
  },

  commission: {
    title: 'Commission | Spinx888',
    description: 'Commission program at Spinx888.',
    robots: 'noindex, nofollow',
  },

  level: {
    title: 'VIP Levels | Spinx888',
    description: 'VIP levels and rewards at Spinx888.',
    keywords: `${BASE_KEYWORDS}, VIP`,
  },

  guides: {
    title: 'App Install Guide | Spinx888',
    description: 'Install the Spinx888 app on Android or iOS for slots, fishing, live casino and card games.',
    keywords: `${BASE_KEYWORDS}, Spinx888 app, install guide`,
  },

  androidGuide: {
    title: 'Android App Install | Spinx888 — Slots, Fishing & Live Casino',
    description:
      'Install Spinx888 on Android: play online slots, fishing games, Shan Koe Mee, Bugyi and live casino on your phone.',
    keywords: `${BASE_KEYWORDS}, Spinx888 Android APK`,
  },

  iosGuide: {
    title: 'iOS App Install | Spinx888 — Slots, Fishing & Live Casino',
    description:
      'Install Spinx888 on iPhone or iPad: slots, fishing arcade, card games and live dealer casino.',
    keywords: `${BASE_KEYWORDS}, Spinx888 iOS app`,
  },

  dreamBooks: {
    title: 'Dream Books | Spinx888',
    description: 'Dream books feature at Spinx888.',
    keywords: BASE_KEYWORDS,
  },

  twoD: {
    title: '2D | Spinx888',
    description: '2D games at Spinx888.',
    keywords: BASE_KEYWORDS,
  },

  threeD: {
    title: '3D | Spinx888',
    description: '3D games at Spinx888.',
    keywords: BASE_KEYWORDS,
  },

  landing: {
    title: 'Spinx888 — Slots, Fishing, Live Casino & Card Games',
    description: BASE_DESC,
    keywords: BASE_KEYWORDS,
  },

  iframe: {
    title: 'Game | Spinx888',
    robots: 'noindex, nofollow',
  },

  verify: {
    title: 'Verify Account | Spinx888',
    robots: 'noindex, nofollow',
  },

  dataTable: {
    title: 'Data | Spinx888',
    robots: 'noindex, nofollow',
  },
};
